// Single source for VegUK content + theme constants.

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_d2be7197-16f4-406f-82de-60ca9e136490/artifacts/a6snxbln_Veg%20UK%20Logo%202.png";

export const HERO_IMAGE =
  "https://images.pexels.com/photos/5425893/pexels-photo-5425893.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400";

export const PREP_IMAGE =
  "https://images.pexels.com/photos/1393382/pexels-photo-1393382.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400";

export const ACCENT_IMAGE =
  "https://images.pexels.com/photos/5425794/pexels-photo-5425794.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400";

export const OBJECTIVES = [
  {
    title: "Define types",
    body: "Codify the vegetarian types in the UK and the food-handling and preparation requirements for each.",
  },
  {
    title: "Educate communities",
    body: "Visit adult and child care centres, schools, hospitals, councils and local communities to raise awareness.",
  },
  {
    title: "Standardise definitions",
    body: "Align with the Food Standards Agency UK, the Vegetarian Society of UK and the Vegan Society of UK.",
  },
  {
    title: "Creative communications",
    body: "Raise awareness of the types using engaging, modern marketing communications.",
  },
  {
    title: "Serve institutions",
    body: "Supply working definitions to care homes, schools, hospitals, airlines, caterers and restaurants.",
  },
  {
    title: "Open forum",
    body: "Provide a forum for queries and clarifications, assisting with the implementation of the defined types.",
  },
];

export const VEG_TYPES = [
  {
    code: "VH",
    name: "Hindu / Lacto Vegetarian",
    tagline: "The most common vegetarian type.",
    short: "Eats dairy products but no meat, fish or eggs.",
    long:
      "Hindu Vegetarian is the most common type and is also referred to as Lacto Vegetarian. These vegetarians eat dairy products but will not eat any meat, fish or eggs.",
    color: "#2E5C46",
    bg: "#E6EFEA",
  },
  {
    code: "VO",
    name: "Ovo Vegetarian",
    tagline: '“Ovo” is the Latin word for egg.',
    short: "As Hindu / Lacto but also eats eggs.",
    long:
      "Ovo Vegetarians will not eat any meat or fish but will eat eggs. Some Ovo Vegetarians may not eat dairy products.",
    color: "#C59346",
    bg: "#F9F2E6",
  },
  {
    code: "VA",
    name: "Allium Vegetarian",
    tagline: "Followed by Vaishnav and Swaminarayan Hindus.",
    short: "As Hindu / Lacto but eats no onions or garlic.",
    long:
      "Allium Vegetarians will not eat foods with onion or garlic. Hindus from the Vaishnav and Swaminarayan sects fall in this category. The latter will not eat asafoetida (Hing) if made using animal leather to crush the powder from the plant sap it originates from.",
    color: "#A34E36",
    bg: "#F5E9E6",
  },
  {
    code: "VJ",
    name: "Jain Vegetarian",
    tagline: "No root vegetables.",
    short: "As Allium but also eats no vegetables which grow underground.",
    long:
      "Jain Vegetarians do not eat any onion, garlic or any vegetables which grow underground like potatoes or carrots. Bread containing yeast, which is a living organism, may not be eaten by some Jains.",
    color: "#8C6A5A",
    bg: "#F0EBE9",
  },
  {
    code: "VV",
    name: "Vegan Vegetarian",
    tagline: "Strictly plant-based.",
    short: "No meat, fish, eggs, dairy or any animal by-products such as honey.",
    long:
      "Vegans are strict vegetarians who do not eat any dairy products or products from animals. These include foods like honey from bees or yoghurt produced from cow’s milk.",
    color: "#658D66",
    bg: "#EBF0EC",
  },
];

export const EXCEPTIONS_TEXT = {
  intro:
    "All by-products of animal slaughter are excluded from certain vegetarian types.",
  items: [
    {
      term: "Gelatine",
      body: "A flavourless ingredient derived from collagen obtained from various animal body parts.",
    },
    {
      term: "Isinglass",
      body: "A kind of gelatine obtained from fish, especially sturgeon, used in making jellies.",
    },
    {
      term: "Animal rennet",
      body: "Curdled milk from the stomach of an un-weaned calf, containing rennin, used in curdling milk for cheese.",
    },
  ],
  notes: [
    "Most cheese is produced from animal rennet and is consumed by some vegetarians.",
    "Chocolates may contain gelatine and are also consumed by some vegetarians.",
    "Use of alcohol is prohibited in all vegetarian food preparation.",
  ],
};

export const PREP_RULES = [
  {
    title: "Dedicated utensils",
    body: "All utensils used for cooking or serving vegetarian food must not be used for any non-vegetarian cooking.",
  },
  {
    title: "Vegetable oils only",
    body: "Vegetable oils (corn, peanut, olive, etc.) must be used for all vegetarian food cooking.",
  },
  {
    title: "No shared frying",
    body: "Items like chips must not be fried in the same oil used for fish or any other non-vegetarian items.",
  },
  {
    title: "Separate handling",
    body: "Staff preparing or serving non-vegetarian food alongside vegetarian food must wear separate gloves and operate from separate counters.",
  },
  {
    title: "No cross-contamination",
    body: "There must be no contamination from non-vegetarian foods, nor across vegetarian food types.",
  },
  {
    title: "FSA compliance",
    body: "Caterers must work in line with the Food Standards Agency UK (FSA) for food safety and hygiene.",
  },
];
